import * as yup from 'yup';
import { ICreatePMSCode } from './PMSCode-utils';

export const PMSCodeInitialValues: ICreatePMSCode = {
  id: '',
  model: '',
  pmCodeDescription: '',
  isActive: 'true',
};
export const PMSCodeSchema = yup.object({
    model: yup.string().trim().required('Model is required'),
    smrOdometerInterval: yup
      .number()
      .typeError('SMR Odometer Interval must be a number')
      .required('SMR Odometer Interval is required')
      .test('is-integer', 'SMR Odometer Interval must be an integer', value =>
        value === undefined ? true : Number.isInteger(value)
      )
      .min(1, 'SMR Odometer Interval must be greater than 0'),
    pmCodeDescription: yup.string().trim().required('PMCode Description is required'),
    isActive: yup.boolean().required('Status is required'),
  });